var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.profile_image},[(_vm.hasImage)?_c('img',{class:_vm.$style.img,attrs:{"src":_vm.url},on:{"error":function($event){_vm.error = true}}}):_c('svg-icon',{class:_vm.$style.img,attrs:{"name":"ic_profile"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }